import { red } from '@material-ui/core/colors';
import { createMuiTheme } from '@material-ui/core/styles';

// A custom theme for this app
export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#556cd6',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
  },
});

// A custom theme for this app
export const darkTheme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      // light: will be calculated from palette.primary.main,
      // main: '#a6d4fa'
      main: '#bbdefb'
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#f6a5c0',
      main: '#f48fb1',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00'
    },
    background: {
      default: '#202020',
      paper: '#303030'
    },
  },
});